import React from "react";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Form, FormActions, Grid, GridColumn, GridRow } from "sprint-common-web";

import { ciFileRecordsRoute, getCiFileRecordQcReviewPageHref } from "../../../../ContentIngestionRoutes";
import { CreateFileRecordNotesSection } from "../common/CreateFileRecordNotesSection";
import { CreateFileRecordFormInputs } from "../CreateFileRecordFormInputs";
import { useCreateFileRecordState } from "../hooks/state/useCreateFileRecordState";
import { useCreateFileRecord } from "../hooks/useCreateFileRecord";
import { CreateVideoFileRecordLanguagesForm } from "./CreateVideoFileRecordLanguagesForm";
import { CreateVideoFileRecordTechInfoForm } from "./CreateVideoFileRecordTechInfoForm";

export const CreateVideoFileRecordForm: React.FC = () => {
    const history = useHistory();

    const { isUpdatePending, createVideo, createFileRecordNotes, saveToHistory } = useCreateFileRecord();
    const { isLoading: isFormLoading } = useCreateFileRecordState();

    const goToFileRecordsListing = () => history.push(ciFileRecordsRoute.path);

    const goToFileRecordDashboard = (fileRecordId: string) =>
        history.push(getCiFileRecordQcReviewPageHref(fileRecordId));

    const { formState, handleSubmit, watch } = useFormContext<CreateFileRecordFormInputs>();

    const submit = async () => {
        const formData = watch();

        const { entityId: fileRecordId } = await createVideo(formData);

        await saveToHistory(formData);

        await createFileRecordNotes(fileRecordId, formData.notes);

        goToFileRecordDashboard(fileRecordId);
    };

    return (
        <Form onSubmit={handleSubmit(submit)}>
            <Grid>
                <GridRow>
                    <GridColumn sm={6}>
                        <CreateVideoFileRecordLanguagesForm />
                        <CreateFileRecordNotesSection />
                    </GridColumn>
                    <GridColumn sm={6}>
                        <CreateVideoFileRecordTechInfoForm />
                    </GridColumn>
                </GridRow>
            </Grid>
            <FormActions
                onCancel={goToFileRecordsListing}
                submitDisabled={formState.isValidating || isFormLoading}
                isLoading={formState.isSubmitting || isUpdatePending}
            />
        </Form>
    );
};
